import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Heading, Text } from '@chakra-ui/react';

function SuggestionBox({ messages, preMessage }) {
  const messagesEndRef = useRef(null);

  // Scroll to the bottom of the messages container when new messages are added
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  const getMessages = () =>
    messages?.map((msg) => {
      const { targetText, textArea, comment } = msg;
      const parts = textArea.split(new RegExp(`(${targetText})`, 'g'));
      return (
        // <Flex key={idx}>
        //   <Box>
        <>
          <Flex
            key={Math.random()}
            alignSelf={'flex-end'}
            bg={'blue.50'}
            w="fit-content"
            // minWidth="100px"
            borderRadius="lg"
            p={2}
            m={1}
          >
            <Text>
              {'Context: '}
              {parts.map((part, index) =>
                part === targetText ? (
                  <Text as="span" fontWeight="bold" key={index}>
                    {part}
                  </Text>
                ) : (
                  <Text as="span" key={index}>
                    {part}
                  </Text>
                )
              )}
            </Text>
          </Flex>
          <Flex
            key={Math.random()}
            alignSelf={'flex-start'}
            bg={'green.100'}
            w="fit-content"
            // minWidth="100px"
            borderRadius="lg"
            p={2}
            m={1}
          >
            <Text>{comment}</Text>
          </Flex>
          {/* </Box> */}
          <div ref={messagesEndRef} />
          {/* </Box>
        </Flex> */}
        </>
      );
    });

  return (
    <Box
      flex="1" // 30% of the width
      minWidth="100px"
      minHeight="560px"
      // maxHeight="70vh"
      overflowY="auto" // Independent scroll for this section
      pb={4}
      bg="gray.50"
      position="relative"
    >
      <Box
        position="sticky"
        top="0" // Stick at the top of the box
        bg="gray.50"
        // p={2}
        zIndex={1} // Ensure it stays on top during scroll
      >
        <Heading pt={2} pl={4} pb={4} size="md">
          Suggestions
        </Heading>
      </Box>
      <Box borderRadius="lg" p={2} bg="white">
        {preMessage && (
          <Flex
            key={Math.random()}
            alignSelf={'flex-start'}
            bg={'green.100'}
            w="fit-content"
            // minWidth="100px"
            borderRadius="lg"
            p={2}
            m={1}
          >
            <Text>{preMessage}</Text>
          </Flex>
        )}
        {getMessages()}
      </Box>
    </Box>
  );
}

SuggestionBox.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.any).isRequired,
  preMessage: PropTypes.string,
};

export default SuggestionBox;
